<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="700px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card v-if="hasLocalizationData">
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Lokalizacja - <strong>{{ localization.customer.name }}</strong>
                </h1>
            </v-card-title>

            <v-card-text class="pa-0">
                <v-container fluid class="px-6 py-0">
                    <v-row>
                        <v-col cols="12">
                            <div class="mb-3">
                                <strong>Adres:</strong> {{ localization.street }}, {{ localization.postCode }} {{ localization.city }}
                            </div>
                        </v-col>
                    </v-row>
                </v-container>

                <v-divider />

                <v-container fluid class="px-6 py-2">
                    <v-row>
                        <v-col cols="12">
                            <h2 class="text-subtitle-1 mb-2">
                                Ekrany
                            </h2>

                            <v-data-table
                                :headers="screensHeaders"
                                :items="localization.outdoorLocalizationScreens"
                                hide-default-footer
                                disable-pagination
                                :mobile-breakpoint="0"
                                dense
                                item-key="id"
                            >
                                <template #item.ordinalNumber="{item}">
                                    {{ item.ordinalNumber }}
                                </template>
                                <template #item.localizationScreenGroup="{item}">
                                    {{ item.localizationScreenGroup.name }}
                                </template>
                                <template #item.localizationScreenSize="{item}">
                                    {{ item.localizationScreenSize.sizeA }} x {{ item.localizationScreenSize.sizeB }}
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-container>

                <template v-if="showTeams">
                    <v-divider />

                    <v-container fluid class="px-6 py-2">
                        <v-row>
                            <v-col cols="12">
                                <h2 class="text-subtitle-1 mb-2">
                                    Ekipy
                                </h2>

                                <v-data-table
                                    :headers="teamsHeaders"
                                    :items="localization.outdoorLocalizationTeams"
                                    hide-default-footer
                                    disable-pagination
                                    :mobile-breakpoint="0"
                                    dense
                                    item-key="id"
                                >
                                    <template #item.name="{item}">
                                        {{ item.name }}
                                    </template>
                                    <template #item.contactPerson="{item}">
                                        {{ item.contactPerson }}
                                    </template>
                                    <template #item.phoneNumber="{item}">
                                        {{ item.phoneNumber }}
                                    </template>
                                    <template #item.contactMail="{item}">
                                        {{ item.contactMail }}
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-container>
                </template>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    @click="onClose"
                >
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { isEmpty } from 'lodash'

export default {
    name: 'LocalizationDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        showTeams: {
            type: Boolean
        },
        localization: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            screensHeaders: [
                {
                    text: 'Numer ekranu',
                    value: 'ordinalNumber',
                    sortable: false,
                },
                {
                    text: 'Grupa',
                    value: 'localizationScreenGroup',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Wymiar',
                    value: 'localizationScreenSize',
                    align: 'center',
                    sortable: false,
                },
            ],
            teamsHeaders: [
                {
                    text: 'Nazwa',
                    value: 'name',
                    sortable: false,
                },
                {
                    text: 'Osoba kontaktowa',
                    value: 'contactPerson',
                    sortable: false,
                },
                {
                    text: 'Nr telefonu',
                    value: 'phoneNumber',
                    sortable: false,
                },
                {
                    text: 'Email',
                    value: 'contactMail',
                    sortable: false,
                }
            ]
        }
    },
    computed: {
        hasLocalizationData() {
            return !isEmpty(this.localization)
        }
    },
    methods: {
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>